module.exports = __webpack_public_path__ + "img/logo-mb-main.568ff496.svg";